import Decimal from "decimal.js";
import UnitPrice from "./unit-price";
import { EstimateItemId } from "./estimate-item";
import PurchaseOrderItems from "./purchase-order-items";

type PurchaseOrderItemId = string;

/**
 * 発注項目
 */
export default class PurchaseOrderItem {
  public constructor(
    public id: PurchaseOrderItemId = "",
    public estimateItemId: EstimateItemId = "",
    public unitName: string = "",
    public unitType: string = "",
    public unitPrice: UnitPrice = new UnitPrice(0),
    public unitLoss: UnitPrice = new UnitPrice(0),
    public amount: Decimal.Value = 0,
    public memo: string = "",
    public items: PurchaseOrderItems = new PurchaseOrderItems()
  ) {}

  public get price(): Decimal {
    return new Decimal(this.unitPrice.items(this.amount));
  }

  public get loss(): Decimal {
    return new Decimal(this.unitLoss.items(this.amount));
  }

  public hasValidItems(): boolean {
    if (this.items.isEmpty()) return true;
    return this.loss.toNumber() === this.items.totalLoss.toNumber();
  }

  public toJSON(): any {
    return {
      id: this.id,
      estimateItemId: this.estimateItemId,
      amount: this.amount,
      unitName: this.unitName,
      unitType: this.unitType,
      unitPrice: this.unitPrice.toNumber(),
      unitLoss: this.unitLoss.toNumber(),
      totalPrice: this.price.toNumber(),
      loss: this.loss.toNumber(),
      memo: this.memo,
      invalid: !this.hasValidItems(),
      items: this.items.toJSON()
    };
  }
}
